import { C } from "./colors";

export const TIER_DEFS = {
  "30 days":  [{key:"now",    label:"NOW",       sub:"Weeks 1–4",    col:C.green }],
  "6 months": [{key:"now",    label:"NOW",       sub:"Weeks 1–4",    col:C.green },
               {key:"next",   label:"NEXT",      sub:"Months 1–3",   col:C.teal  },
               {key:"later",  label:"6 MONTHS",  sub:"Months 3–6",   col:C.orange}],
  "12 months":[{key:"now",    label:"NOW",       sub:"Weeks 1–4",    col:C.green },
               {key:"next",   label:"NEXT",      sub:"Months 1–3",   col:C.teal  },
               {key:"later",  label:"6 MONTHS",  sub:"Months 3–6",   col:C.orange},
               {key:"year1",  label:"12 MONTHS", sub:"Months 6–12",  col:C.purple}],
  "3 years":  [{key:"now",    label:"NOW",       sub:"Weeks 1–4",    col:C.green },
               {key:"next",   label:"NEXT",      sub:"Months 1–3",   col:C.teal  },
               {key:"later",  label:"6 MONTHS",  sub:"Months 3–6",   col:C.orange},
               {key:"year1",  label:"YEAR 1",    sub:"Months 6–12",  col:C.purple},
               {key:"year2_3",label:"YEARS 2–3", sub:"12–36 Months", col:C.navy  }],
  "5 years":  [{key:"now",    label:"NOW",       sub:"Weeks 1–4",    col:C.green },
               {key:"next",   label:"NEXT",      sub:"Months 1–3",   col:C.teal  },
               {key:"later",  label:"6 MONTHS",  sub:"Months 3–6",   col:C.orange},
               {key:"year1",  label:"YEAR 1",    sub:"Months 6–12",  col:C.purple},
               {key:"year2_3",label:"YEARS 2–3", sub:"12–36 Months", col:C.navy  },
               {key:"year4_5",label:"YEARS 4–5", sub:"3–5 Years",    col:C.muted }],
};

// ── Material taxonomy ─────────────────────────────────────
// divertible values: compost | cardboard | paper | glass | rigid_plastic |
//   aluminum | soft_plastics | specialty_textile | specialty_medical |
//   grease | self_haul | reduce | none | already_diverted
// Each material also carries a `stream` — its closest match in WASTE_STREAMS (see
// constants/wasteData.js), so audit-characterized materials can be cross-referenced
// against the wasteData/wasteAccounts hauling streams where useful.
export const MATERIALS = {
  hospitality:[
    // Organics
    {id:"food_waste",     label:"Food Waste",                        divertible:"compost",          stream:"Food Waste",  hint:"Kitchen prep, plate waste, expired food"},
    {id:"coffee_grounds", label:"Coffee Grounds & Filters",          divertible:"compost",          stream:"Food Waste",  hint:"High volume in F&B operations"},
    // Paper & cardboard
    {id:"cardboard",      label:"Cardboard & Boxes",                 divertible:"cardboard",        stream:"Cardboard",   hint:"Shipping boxes, flattened corrugated"},
    {id:"paper_boxboard", label:"Paper & Paperboard (mixed)",        divertible:"paper",            stream:"Paper",       hint:"Office paper, cartons, boxboard packaging"},
    {id:"paper_cups",     label:"Paper Cups & Napkins",              divertible:"compost",          stream:"Compost",     hint:"Usually compostable if service exists; not recyclable"},
    {id:"receipts",       label:"Receipts & Thermal Paper",          divertible:"none",             stream:"MSW",         hint:"BPA coating makes these non-recyclable"},
    // Containers & packaging
    {id:"glass",          label:"Glass Bottles & Jars",              divertible:"glass",            stream:"Glass",       hint:"Bar, kitchen, and minibar glass"},
    {id:"aluminum",       label:"Aluminum Cans & Foil",              divertible:"aluminum",         stream:"Metal",       hint:"High value — recyclable nearly everywhere"},
    {id:"rigid_plastic",  label:"Rigid Plastic Containers (#1–#2)", divertible:"rigid_plastic",    stream:"Plastic",     hint:"Water bottles, deli containers, jugs"},
    {id:"cartons",        label:"Cartons (milk, juice, broth)",      divertible:"paper",            stream:"Paper",       hint:"Recyclable where carton programs exist"},
    {id:"soft_plastics",  label:"Soft Plastics & Film",              divertible:"soft_plastics",    stream:"Plastic",     hint:"Wrap, bags, shrink film — specialty vendor needed"},
    {id:"snack_wrappers", label:"Snack Wrappers & Foil Pouches",     divertible:"soft_plastics",    stream:"Plastic",     hint:"Multi-layer film — TerraCycle or specialty only"},
    // Textiles & other
    {id:"linens",         label:"Linens & Textiles",                 divertible:"specialty_textile",stream:"Other",       hint:"Towels, uniforms, bedding — donate or specialty"},
    {id:"wood_pallets",   label:"Wood Pallets",                      divertible:"self_haul",        stream:"Other",       hint:"Often self-haul or vendor pickup available"},
    {id:"grease",         label:"Cooking Oil / Grease",              divertible:"grease",           stream:"Grease/FOG",  hint:"Biodiesel vendors will often pick up for free"},
    {id:"guest_waste",    label:"Guest Room Waste (mixed)",          divertible:"reduce",           stream:"MSW",         hint:"Mixed stream — source separation program needed"},
    {id:"bar_trash",      label:"Bar Trash (mixed)",                 divertible:"reduce",           stream:"MSW",         hint:"Mixed stream — sort and source reduction opportunity"},
    {id:"true_landfill",  label:"True Landfill — No Pathway",        divertible:"none",             stream:"MSW",         hint:"Items with no current diversion option"},
  ],
  healthcare:[
    // Organics
    {id:"food_waste",     label:"Cafeteria & Kitchen Food Waste",    divertible:"compost",          stream:"Food Waste",  hint:"Prep waste, tray return, expired food"},
    {id:"coffee_grounds", label:"Coffee Grounds & Break Room Organics", divertible:"compost",       stream:"Food Waste",  hint:"Break room — often composted with food waste"},
    // Paper & cardboard
    {id:"cardboard",      label:"Cardboard & Shipping Boxes",        divertible:"cardboard",        stream:"Cardboard",   hint:"Supply deliveries — high volume"},
    {id:"office_paper",   label:"Office & Administrative Paper",     divertible:"paper",            stream:"Paper",       hint:"Offices, nursing stations, waiting rooms"},
    {id:"exam_paper",     label:"Exam Table Paper & Wipes",          divertible:"reduce",           stream:"MSW",         hint:"Source reduction is primary pathway"},
    {id:"paper_towels",   label:"Paper Towels",                      divertible:"reduce",           stream:"MSW",         hint:"Volume driver — reduction and hand dryer conversion"},
    {id:"paper_cups",     label:"Paper Cups (break rooms)",          divertible:"compost",          stream:"Compost",     hint:"Compostable if service exists; reduce via mugs program"},
    // Containers
    {id:"aluminum",       label:"Aluminum Cans",                     divertible:"aluminum",         stream:"Metal",       hint:"Break rooms and cafeteria — recyclable everywhere"},
    {id:"rigid_plastic",  label:"Rigid Plastic Containers (#1–#2)", divertible:"rigid_plastic",    stream:"Plastic",     hint:"Water bottles, food containers"},
    {id:"cartons",        label:"Cartons & Beverage Containers",     divertible:"paper",            stream:"Paper",       hint:"Cafeteria — recyclable where programs exist"},
    // Medical & specialty
    {id:"soft_plastics",  label:"Soft Plastics & Wrap (non-medical)",divertible:"soft_plastics",    stream:"Plastic",     hint:"Supply packaging — specialty vendor or TerraCycle"},
    {id:"medical_packaging",label:"Medical Supplies Packaging",      divertible:"specialty_medical",stream:"Medical Waste",hint:"Gowns, tubing wrap — Stericycle or Sharps Compliance"},
    {id:"gloves",         label:"Nitrile & Latex Gloves",            divertible:"specialty_medical",stream:"Medical Waste",hint:"Specialty recycling programs exist (Kimberly-Clark, TerraCycle)"},
    {id:"blue_gowns",     label:"Reusable Gowns & Blue Bedding",     divertible:"specialty_textile",stream:"Other",       hint:"Laundry/reuse program or specialty textile vendor"},
    {id:"yellow_gowns",   label:"Disposable Yellow Isolation Gowns", divertible:"specialty_medical",stream:"Medical Waste",hint:"Some specialty programs — verify with vendor"},
    {id:"break_room",     label:"Break Room Trash (mixed)",          divertible:"reduce",           stream:"MSW",         hint:"Mixed stream — cups, wrappers, cutlery. Reduce + sort."},
    // Regulated streams — no diversion from this tool's scope
    {id:"rmw",            label:"Regulated Medical Waste (RMW)",     divertible:"none",             stream:"Medical Waste",hint:"Contracted separately — outside diversion scope"},
    {id:"sharps",         label:"Sharps & Biohazard Containers",     divertible:"none",             stream:"Medical Waste",hint:"Contracted separately — never sort or open"},
    {id:"already_diverted",label:"Mixed Recycling (already captured)",divertible:"already_diverted",stream:"Mixed Recycling",hint:"Already in your recycling stream — note for baseline"},
    {id:"true_landfill",  label:"True Landfill — No Pathway",        divertible:"none",             stream:"MSW",         hint:"Items with no current diversion option"},
  ],
};

// Resolves effective divertibility given hauler constraints
export function resolveOpportunity(materialDivertible, hauler, baseline) {
  const canSwitch = hauler.can_switch !== "no";

  // Passthrough states
  if (materialDivertible === "none") return "none";
  if (materialDivertible === "already_diverted") return "already_diverted";
  if (materialDivertible === "reduce") return "reduce";

  // Organics / compost
  if (materialDivertible === "compost") {
    if (baseline.composting === "yes") return "feasible_now";
    if (hauler.offers_composting === "yes") return "feasible_now";
    return canSwitch ? "new_vendor" : "constrained";
  }

  // Corrugated cardboard (separate stream)
  if (materialDivertible === "cardboard") {
    if (baseline.cardboard_active === "yes") return "feasible_now";
    if (hauler.offers_cardboard === "yes") return "feasible_now";
    return canSwitch ? "new_vendor" : "constrained";
  }

  // Mixed paper & cartons — goes through recycling stream
  if (materialDivertible === "paper") {
    if (baseline.recycling === "yes" || baseline.single_stream === "yes") return "feasible_now";
    if (hauler.offers_recycling === "yes") return "feasible_now";
    return canSwitch ? "new_vendor" : "constrained";
  }

  // Glass — separate acceptance required
  if (materialDivertible === "glass") {
    if (hauler.offers_glass === "yes") return "feasible_now";
    // Glass is almost never accepted in curbside single-stream at mountain resorts
    return canSwitch ? "new_vendor" : "constrained";
  }

  // Rigid plastics #1-#2 — needs active recycling stream
  if (materialDivertible === "rigid_plastic") {
    if (baseline.recycling === "yes" || baseline.single_stream === "yes") return "feasible_now";
    if (hauler.offers_recycling === "yes") return "feasible_now";
    return canSwitch ? "new_vendor" : "constrained";
  }

  // Aluminum — high value, recyclable through any active recycling stream
  if (materialDivertible === "aluminum") {
    if (baseline.recycling === "yes" || baseline.single_stream === "yes") return "feasible_now";
    if (hauler.offers_recycling === "yes") return "feasible_now";
    return canSwitch ? "new_vendor" : "constrained";
  }

  // Soft plastics / film — NEVER goes in curbside recycling
  // Requires a specialty program (store drop-off, TerraCycle, specialty hauler)
  if (materialDivertible === "soft_plastics") {
    if (hauler.offers_soft_plastic === "yes") return "feasible_now";
    return canSwitch ? "new_vendor" : "constrained";
  }

  // Specialty medical (gloves, gowns, medical packaging)
  // Requires specific vendor — cannot go through normal recycling
  if (materialDivertible === "specialty_medical") {
    // These always require a specialty vendor — self-haul isn't viable
    return canSwitch ? "new_vendor" : "constrained";
  }

  // Textiles / linens — donate, reuse program, or specialty hauler
  if (materialDivertible === "specialty_textile") {
    return "linens_multi";
  }

  // Cooking grease — usually free pickup by biodiesel vendors
  if (materialDivertible === "grease") {
    if (baseline.grease === "yes") return "feasible_now";
    return "new_vendor"; // grease vendors will come regardless of hauler lock
  }

  // Self-haul items (pallets, bulky materials)
  if (materialDivertible === "self_haul") {
    return canSwitch ? "new_vendor" : "constrained";
  }

  return "new_vendor";
}

export const OPP_DISPLAY = {
  feasible_now:    {label:"Divertible Now",              color:C.green,  icon:"✅"},
  new_vendor:      {label:"Requires New Vendor",         color:C.orange, icon:"🔄"},
  constrained:     {label:"Constrained — No Vendor Option", color:C.muted,icon:"🚫"},
  reduce:          {label:"Reducible at Source",         color:C.teal,   icon:"⬇️"},
  linens_multi:    {label:"Donate / Reduce / Specialty", color:C.purple, icon:"♻️"},
  compost:         {label:"Divertible via Compost",      color:C.green,  icon:"✅"},
  recycling:       {label:"Divertible via Recycling",    color:C.teal,   icon:"✅"},
  cardboard:       {label:"Cardboard Collection",        color:C.teal,   icon:"✅"},
  glass:           {label:"Glass Recycling",             color:C.teal,   icon:"✅"},
  specialty:       {label:"Specialty Vendor",            color:C.orange, icon:"🔄"},
  donation:        {label:"Donation / Reuse",            color:C.purple, icon:"✅"},
  none:            {label:"True Landfill",               color:C.muted,  icon:"🚫"},
  already_diverted:{label:"Already Diverted",            color:C.green,  icon:"✅"},
};

// Hauler profile questions (top section)
export const HAULER_QUESTIONS = [
  {id:"hauler_name",      label:"Current waste hauler name",                                    type:"text",    placeholder:"e.g. Waste Connections, Republic Services"},
  {id:"can_switch",       label:"Can you change haulers or add a second vendor?",                type:"tri",     opts:[["yes","Yes"],["requires_approval","Needs Approval"],["no","No"]]},
  {id:"offers_recycling", label:"Does your hauler offer recycling pickup?",                      type:"tri",     opts:[["yes","Yes"],["no","No"],["unknown","Unknown"]]},
  {id:"offers_composting",label:"Does your hauler offer composting / organics pickup?",          type:"tri",     opts:[["yes","Yes"],["no","No"],["unknown","Unknown"]]},
  {id:"offers_glass",     label:"Does your hauler accept glass for recycling?",                  type:"tri",     opts:[["yes","Yes"],["no","No"],["unknown","Unknown"]]},
  {id:"offers_cardboard", label:"Does your hauler accept cardboard separately?",                 type:"tri",     opts:[["yes","Yes"],["no","No"],["unknown","Unknown"]]},
  {id:"offers_soft_plastic",label:"Does your hauler accept soft plastics / film?",              type:"tri",     opts:[["yes","Yes"],["no","No"],["unknown","Unknown"]]},
];

export const BASELINE_Q = {
  hospitality:[
    {id:"composting",    label:"Do you currently have active composting service?",              type:"yesno"},
    {id:"single_stream", label:"Do you have single-stream recycling pickup?",                   type:"yesno"},
    {id:"recycling",     label:"Do you have mixed / separated recycling pickup?",               type:"yesno"},
    {id:"cardboard_active",label:"Is cardboard currently being collected separately?",          type:"yesno"},
    {id:"grease",        label:"Do you have a grease trap / cooking oil pickup?",               type:"yesno"},
    {id:"donation",      label:"Do you donate usable goods (linens, food, equipment)?",         type:"yesno"},
    {id:"frequency",     label:"How often is your landfill dumpster collected?",                type:"select", options:["Daily","3x/week","2x/week","Weekly","Bi-weekly","Monthly"]},
    {id:"overflow",      label:"Does your landfill dumpster overflow before pickup?",           type:"yesno3"},
    {id:"signage",       label:"Are waste stations clearly labeled with signage?",              type:"yesno"},
    {id:"staff_training",label:"Have staff received waste sorting training in the past year?",  type:"yesno"},
    {id:"green_champion",label:"Do you have a designated internal sustainability contact?",     type:"yesno"},
  ],
  healthcare:[
    {id:"composting",    label:"Do you currently have active composting service?",              type:"yesno"},
    {id:"single_stream", label:"Do you have single-stream recycling pickup?",                   type:"yesno"},
    {id:"recycling",     label:"Do you have mixed / separated recycling pickup?",               type:"yesno"},
    {id:"cardboard_active",label:"Is cardboard currently being collected separately?",          type:"yesno"},
    {id:"rmw_vendor",    label:"Do you have a contracted RMW disposal vendor?",                 type:"yesno"},
    {id:"sharps",        label:"Do you have a sharps container and disposal program?",          type:"yesno"},
    {id:"linen_reuse",   label:"Do you have a linen reuse / laundering program?",               type:"yesno"},
    {id:"frequency",     label:"How often is your landfill dumpster collected?",                type:"select", options:["Daily","3x/week","2x/week","Weekly","Bi-weekly","Monthly"]},
    {id:"overflow",      label:"Does your landfill dumpster overflow before pickup?",           type:"yesno3"},
    {id:"signage",       label:"Are waste stations clearly labeled with signage?",              type:"yesno"},
    {id:"staff_training",label:"Have EVS/facilities staff received waste training in past year?",type:"yesno"},
    {id:"green_champion",label:"Do you have a designated internal sustainability contact?",     type:"yesno"},
  ],
};
